import React, { FC, useContext, useEffect } from 'react';
import { CheckboxFilterOption } from '../types';
import { SelectedVariantsContext } from '../../../SelectedVariantsContext';
import {
  FilterCheckboxWithContext,
  FilterCheckboxWithContextProps,
} from '../../components/FilterCheckboxWithContext';

const selectedVariantsCheckboxFilterId =
  'omicsExplorer.filters.variantSelection';

const SelectedVariantsFilterCheckbox: FC<
  FilterCheckboxWithContextProps
> = props => {
  const { showSelectedVariants, setShowSelectedVariants } = useContext(
    SelectedVariantsContext,
  );

  useEffect(() => {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    setShowSelectedVariants(props.injectedProps.checkboxOption.searchValue);
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  }, [props.injectedProps.checkboxOption.searchValue, setShowSelectedVariants]);

  return (
    <FilterCheckboxWithContext
      {...props}
      isChecked={showSelectedVariants}
      setIsChecked={setShowSelectedVariants}
    />
  );
};

const defaultMessage = 'Selected Variants';

export const config: CheckboxFilterOption = {
  id: selectedVariantsCheckboxFilterId,
  title: {
    id: selectedVariantsCheckboxFilterId,
    defaultMessage,
  },
  content: SelectedVariantsFilterCheckbox,
  injectedProps: {
    checkboxOption: {
      id: `${selectedVariantsCheckboxFilterId}.checkboxOption`,
      searchValue: false,
      intlLabel: {
        id: `${selectedVariantsCheckboxFilterId}.checkbox`,
        defaultMessage,
      },
    },
  },
};
